import classnames from 'classnames';
import { forwardRef, useImperativeHandle, useState } from 'react';

import { usePositionEffect } from '../utils';

import styles from './StyledTable.module.scss';
import { StyledTableProps } from './StyledTable.types';

export const StyledTable = forwardRef<HTMLDivElement, StyledTableProps>(
  (
    {
      containerClassName,
      color = 'white',
      size,
      stickyHeader,
      stickyHeaderDistance,
      className,
      ...props
    },
    ref
  ) => {
    const [verticalScrolling, setVerticalScrolling] = useState(false);
    const [horizontalScrolling, setHorizontalScrolling] = useState(false);

    const innerRef = usePositionEffect(() => {
      if (!innerRef.current?.parentElement) {
        setVerticalScrolling(false);
        setHorizontalScrolling(false);
      } else {
        setVerticalScrolling(
          innerRef.current.parentElement.clientHeight !==
            innerRef.current.parentElement.scrollHeight
        );
        setHorizontalScrolling(
          innerRef.current.parentElement.clientWidth !== innerRef.current.parentElement.scrollWidth
        );
      }
    }, []);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    useImperativeHandle(ref, () => innerRef.current!);

    return (
      <div
        className={classnames(styles.container, containerClassName, styles[size])}
        data-table-size={size}
        data-row-color={color}
        data-sticky-header={stickyHeader ? true : undefined}
        data-sticky-header-distance={stickyHeaderDistance}
        data-vertical-scrolling={verticalScrolling ? true : undefined}
        data-horizontal-scrolling={horizontalScrolling ? true : undefined}
      >
        <div
          ref={innerRef}
          className={classnames(styles.table, className)}
          data-role="table"
          {...props}
        />
      </div>
    );
  }
);
